import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { SmartfeedMessage } from '@model/product/smartfeed/smartfeed.model';
import { PlatformService } from '@util/platform.service';
import { ScoopfreeActivityType } from '@model/product/scoopfree/activity/scoopfree-activity-type.model';
import { SmartfeedMessageType } from '@model/product/smartfeed/activity/smartfeed-activity-type.model';

@Component({
  selector: 'app-smartfeed-latest-messages',
  templateUrl: './smartfeed-latest-messages.component.html',
  styleUrls: ['./smartfeed-latest-messages.component.scss'],
})
export class SmartfeedLatestMessagesComponent
  implements OnInit, OnChanges {
  @Input()
  productActivities: Array<SmartfeedMessage>;

  activities: Array<{
    date: string;
    activities: Array<SmartfeedMessage>;
    isCollapsed?: boolean;
  }>;

  activityTypes: Array<ScoopfreeActivityType>;

  selectedActivityType: ScoopfreeActivityType;
  collapseAll = false;

  constructor(private platformService: PlatformService) {}

  ngOnInit() {
    this.activityTypes = this.platformService.getById(
      'smartfeed',
    ).activityTypes;
    this.selectActivityType();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedActivityType = ScoopfreeActivityType.SHOW_ALL;
    this.selectActivityType();
  }

  selectActivityType() {
    this.collapseAll = false;
    this.activities = this.groupActivityByDate();
  }

  expandAll() {
    this.collapseAll = !this.collapseAll;
    if (this.activities) {
      for (const a of this.activities) {
        a.isCollapsed = this.collapseAll;
      }
    }
  }

  /**
   * groupActivityByDate
   *
   * @returns a json object array of groups of activities that are grouped by either matching date, week or month
   */
  groupActivityByDate(): Array<{
    date: string;
    activities: Array<SmartfeedMessage>;
  }> {
    if (this.productActivities) {
      const groups = this.productActivities
        .filter((a: SmartfeedMessage) => {
          const mType =
            SmartfeedMessageType[
              (a.messageType as unknown) as keyof typeof SmartfeedMessageType
            ];
          switch (this.selectedActivityType) {
            case ScoopfreeActivityType.SHOW_ALL:
              return true;
            case ScoopfreeActivityType.FOOD_STATUS:
              return (
                mType === SmartfeedMessageType.FOOD_LOW ||
                mType === SmartfeedMessageType.FOOD_HIGH
              );
            case ScoopfreeActivityType.CUST_VIEW:
              return (
                mType === SmartfeedMessageType.FEED_DONE ||
                mType === SmartfeedMessageType.WILL_MESSAGE ||
                mType === SmartfeedMessageType.FOOD_LOW ||
                mType ===
                  SmartfeedMessageType.FEED_ERROR_MOTOR_SWITCH ||
                mType ===
                  SmartfeedMessageType.FEED_ERROR_MOTOR_CURRENT
              );
            case ScoopfreeActivityType.MEALS:
              return mType === SmartfeedMessageType.FEED_DONE;
            case ScoopfreeActivityType.DISCONNECT:
              return mType === SmartfeedMessageType.WILL_MESSAGE;
            case ScoopfreeActivityType.ERROR:
              return (
                mType ===
                  SmartfeedMessageType.FEED_ERROR_MOTOR_SWITCH ||
                mType ===
                  SmartfeedMessageType.FEED_ERROR_MOTOR_CURRENT ||
                mType === SmartfeedMessageType.OTA_TASK_UPGRADE_FAILED
              );
            default:
              return true;
          }
        })
        .reduce((g: {}, activity: SmartfeedMessage) => {
          const date = new Date(activity.createdAt)
            .toISOString()
            .split('T')[0];

          if (!g[date]) {
            g[date] = [];
          }
          g[date].push(activity);

          return g;
        }, {});

      const groupArray: Array<{
        date: string;
        activities: Array<SmartfeedMessage>;
      }> = Object.keys(groups).map((date: string) => {
        return {
          date,
          activities: groups[date],
        };
      });

      for (const g of groupArray) {
        g.activities.sort(
          (a: SmartfeedMessage, b: SmartfeedMessage) => {
            return (
              new Date(b.createdAt).getTime() -
              new Date(a.createdAt).getTime()
            );
          },
        );
      }

      return groupArray.sort(
        (
          a: { date: string; activities: any },
          b: { date: string; activities: any },
        ) => {
          return (
            new Date(b.date).getTime() - new Date(a.date).getTime()
          );
        },
      );
    }
    return null;
  }
}
